NavbarDirective.$inject = ['$timeout'];

export function NavbarDirective($timeout) {
    return {
        link(scope, element) {
            const header = element[0];
            const navbarHeader = header.querySelector('.navbar-header');

            function updateBackofficeHeaderTopDistance(height) {
                document.documentElement.style.setProperty(
                    '--angular-header-height',
                    `${height.toFixed()}px`,
                );
            }

            function getHeaderHeight() {
                if (window.matchMedia('(max-width: 991px)').matches) {
                    return navbarHeader
                        ? navbarHeader.scrollHeight
                        : header.scrollHeight;
                }

                return header.offsetHeight;
            }

            function applyHeaderHeight() {
                const height = getHeaderHeight();

                if (height !== lastHeight) {
                    updateBackofficeHeaderTopDistance(height);
                    lastHeight = height;
                }
            }

            let lastHeight = null;

            const resizeObserver = new ResizeObserver(() => {
                applyHeaderHeight();
            });

            $timeout(() => {
                applyHeaderHeight();
                resizeObserver.observe(header);

                if (navbarHeader) {
                    resizeObserver.observe(navbarHeader);
                }
            }, 0);

            scope.$on('$destroy', () => {
                resizeObserver.disconnect();
            });
        },
    };
}
